import { createContext, useContext } from 'react'
import {
  NavigateOptions,
  SetURLSearchParams,
  URLSearchParamsInit,
  useSearchParams
} from 'react-router-dom'

const queryStateContext = createContext<[URLSearchParams, SetURLSearchParams]>([
  new URLSearchParams(),
  () => {}
])

export function QueryStateProvider({
  children
}: {
  children: React.ReactNode
}) {
  const [searchParams, setSearchParams] = useSearchParams()

  return (
    <queryStateContext.Provider
      value={[
        searchParams,
        (
          nextInit?:
            | URLSearchParamsInit
            | ((prev: URLSearchParams) => URLSearchParamsInit),
          navigateOpts?: NavigateOptions
        ) => setSearchParams(nextInit, { ...navigateOpts, replace: true })
      ]}
    >
      {children}
    </queryStateContext.Provider>
  )
}

export const useQueryStateContext = () => useContext(queryStateContext)
